module.exports = __webpack_public_path__ + "static/ak_logo-a2bd7f2aa056b051af636770e1b520d2.svg";